import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useBrowserSession, isHostSession } from '../_lib/browserSession';


const PrivateRoute = ({ component: Component, ...rest }) => {
    const session = useBrowserSession();
    const allowed = isHostSession(session);
    return (
        <Route {...rest} render={props => (
            allowed ?<>
            
            <p style={{display:'none'}}>private route active</p>
            
            <Component {...props} /> </>: <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )} />
    );

};

export default PrivateRoute;
